/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAdminItem = /* GraphQL */ `
  mutation CreateAdminItem($input: CreateAdminInput) {
    createAdminItem(input: $input) {
      country
      firstName
      lastName
      email
      phone
      role
      hasAccessed
      createdBy
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const createTeamItem = /* GraphQL */ `
  mutation CreateTeamItem($input: CreateTeamInput) {
    createTeamItem(input: $input) {
      billingId
      title
      teamUsers {
        items {
          teamId
          userId
          createdAt
          updatedAt
          owners
          id
          teamTeamUsersId
        }
        nextToken
      }
      ownerUserId
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const createTeamUserItem = /* GraphQL */ `
  mutation CreateTeamUserItem($input: CreateTeamUserInput) {
    createTeamUserItem(input: $input) {
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owners
      id
      teamTeamUsersId
    }
  }
`;
export const deleteTeamUserItem = /* GraphQL */ `
  mutation DeleteTeamUserItem($input: DeleteTeamUserInput) {
    deleteTeamUserItem(input: $input) {
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owners
      id
      teamTeamUsersId
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount {
    deleteAccount {
      id
      identityId
      email
      about
      firstName
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      billingId
      billing {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      onboardingStatus
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userType
      reportReasons
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAdminItem = /* GraphQL */ `
  mutation DeleteAdminItem($input: DeleteAdminInput) {
    deleteAdminItem(input: $input) {
      country
      firstName
      lastName
      email
      phone
      role
      hasAccessed
      createdBy
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const createTranslation = /* GraphQL */ `
  mutation CreateTranslation($input: CreateTranslationInput) {
    createTranslation(input: $input) {
      language
      namespace
      data
    }
  }
`;
export const updateTranslation = /* GraphQL */ `
  mutation UpdateTranslation($input: UpdateTranslationInput) {
    updateTranslation(input: $input) {
      language
      namespace
      data
    }
  }
`;
export const stripePaymentCheckout = /* GraphQL */ `
  mutation StripePaymentCheckout($input: StripePaymentCheckoutInput) {
    stripePaymentCheckout(input: $input) {
      url
    }
  }
`;
export const stripeCreateCustomerPortal = /* GraphQL */ `
  mutation StripeCreateCustomerPortal($input: StripeCustomerPortalInput) {
    stripeCreateCustomerPortal(input: $input) {
      url
    }
  }
`;
export const stripeUpdateSubscription = /* GraphQL */ `
  mutation StripeUpdateSubscription($input: StripeUpdateSubscription) {
    stripeUpdateSubscription(input: $input)
  }
`;
export const blockUser = /* GraphQL */ `
  mutation BlockUser($input: BlockUserInput) {
    blockUser(input: $input) {
      id
      identityId
      email
      about
      firstName
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      billingId
      billing {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      onboardingStatus
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userType
      reportReasons
      createdAt
      updatedAt
      owner
    }
  }
`;
export const reportUser = /* GraphQL */ `
  mutation ReportUser($input: ReportUserInput) {
    reportUser(input: $input) {
      id
      identityId
      email
      about
      firstName
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      billingId
      billing {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      onboardingStatus
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userType
      reportReasons
      createdAt
      updatedAt
      owner
    }
  }
`;
export const publishUserMessage = /* GraphQL */ `
  mutation PublishUserMessage($userId: ID!) {
    publishUserMessage(userId: $userId) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const validateUserIAPReceipt = /* GraphQL */ `
  mutation ValidateUserIAPReceipt($input: VerifyIAPInput) {
    validateUserIAPReceipt(input: $input) {
      customerId
      userId
      planId
      productId
      autoRenewProductId
      subscriptionId
      status
      trialUsed
      paymentProvider
      purchaseToken
      plan
      expiresAt
      cancelledAt
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const updateAdmin = /* GraphQL */ `
  mutation UpdateAdmin(
    $input: UpdateAdminInput!
    $condition: ModelAdminConditionInput
  ) {
    updateAdmin(input: $input, condition: $condition) {
      country
      firstName
      lastName
      email
      phone
      role
      hasAccessed
      createdBy
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const createConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation(
    $input: DeleteConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    deleteConversation(input: $input, condition: $condition) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const createUserConversation = /* GraphQL */ `
  mutation CreateUserConversation(
    $input: CreateUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    createUserConversation(input: $input, condition: $condition) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const updateUserConversation = /* GraphQL */ `
  mutation UpdateUserConversation(
    $input: UpdateUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    updateUserConversation(input: $input, condition: $condition) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const deleteUserConversation = /* GraphQL */ `
  mutation DeleteUserConversation(
    $input: DeleteUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    deleteUserConversation(input: $input, condition: $condition) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const createOption = /* GraphQL */ `
  mutation CreateOption(
    $input: CreateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    createOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateOption = /* GraphQL */ `
  mutation UpdateOption(
    $input: UpdateOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    updateOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteOption = /* GraphQL */ `
  mutation DeleteOption(
    $input: DeleteOptionInput!
    $condition: ModelOptionConditionInput
  ) {
    deleteOption(input: $input, condition: $condition) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    updateTeam(input: $input, condition: $condition) {
      billingId
      title
      teamUsers {
        items {
          teamId
          userId
          createdAt
          updatedAt
          owners
          id
          teamTeamUsersId
        }
        nextToken
      }
      ownerUserId
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
export const deleteTeamUser = /* GraphQL */ `
  mutation DeleteTeamUser(
    $input: DeleteTeamUserInput!
    $condition: ModelTeamUserConditionInput
  ) {
    deleteTeamUser(input: $input, condition: $condition) {
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owners
      id
      teamTeamUsersId
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      identityId
      email
      about
      firstName
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      billingId
      billing {
        customerId
        userId
        planId
        productId
        autoRenewProductId
        subscriptionId
        status
        trialUsed
        paymentProvider
        purchaseToken
        plan
        expiresAt
        cancelledAt
        createdAt
        updatedAt
        id
        owner
      }
      onboardingStatus
      teamId
      team {
        billingId
        title
        teamUsers {
          nextToken
        }
        ownerUserId
        createdAt
        updatedAt
        id
        owner
      }
      userType
      reportReasons
      createdAt
      updatedAt
      owner
    }
  }
`;
